import { featuredItems, type GossipItem } from "@/mocks/gossip";

const toneText: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-900",
};

function Card({ item }: { item: GossipItem }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={item.img}
          alt={`${item.title} - 吃瓜八卦考古旧料档案`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className={`absolute left-3 top-3 rounded-md px-2.5 py-1 text-xs font-semibold ${toneText[item.tagTone]}`}>
          {item.tag}
        </span>
        <span className="absolute bottom-3 right-3 rounded-md bg-foreground-900/70 px-2 py-1 text-[11px] font-medium text-background-50">
          {item.year}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-fire-line text-accent-500" />
          <span>热度 {item.hot}%</span>
        </div>
        <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950">{item.title}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{item.summary}</p>
        <a
          href="#subscribe"
          className="editorial-link mt-4 inline-flex w-fit items-center gap-1 text-sm font-semibold text-accent-600"
        >
          查看完整时间线 <i className="ri-arrow-right-line" />
        </a>
      </div>
    </article>
  );
}

export default function HotFeatured() {
  return (
    <section id="hot" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-2 border-l-4 border-accent-500 pl-4">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-secondary-600">今日热瓜 · Hot Gossip</p>
          <h2 className="font-heading text-3xl font-black text-foreground-950 md:text-4xl">本周热推 · 值得回味的旧瓜</h2>
          <p className="max-w-2xl text-sm text-foreground-600">
            每一则都经过编辑部重新核对时间线，老料新挖，带你把当年的热闹看得明明白白。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {featuredItems.map((item) => (
            <Card key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}